import MyPets from './components/MyPets';

export const petsRoutes = [
  {
    path: '/',
    exact: true,
    className: '',
    component: MyPets,
    id: 'my-pets',
  },
];
